import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { ITrainingSet } from '../../../types/my-types';
import UploadPicker from '../../upload/UploadPicker';
import { UploadContext } from '../../upload/UploadContext';
import IconButtonWhiteBg from '../../common/IconButtonWhiteBg';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

interface ITrainingSetAddDocumentsProps {
  trainingSet?: ITrainingSet;
}

const TrainingSetAddDocuments: React.FC<ITrainingSetAddDocumentsProps> = ({ trainingSet }) => {
  const {
    setLabel,
    setUploading,
    open,
    setOpen,
    display,
    setAcceptedDocs,
    setOption,
    updateTotalUploadedDocs,
    updateTotalAcceptedDocs,
    updateTotalFailedDocs,
  } = React.useContext(UploadContext);

  const setUploadingLS = (value: boolean) => {
    localStorage.setItem('uploading', value + '');
    setUploading(value);
  };

  const dismissModal = () => {
    setUploading(false);
    setUploadingLS(false);
    setAcceptedDocs([]);
    setOpen(false);
    setOption(0);
    updateTotalUploadedDocs(0);
    updateTotalAcceptedDocs(0);
    updateTotalFailedDocs(0);
  };

  React.useEffect(() => {
    setLabel(trainingSet!.label);
  }, [trainingSet, setLabel]);

  return (
    <div id="add-docs" style={{ display: 'inline' }}>
      <IconButtonWhiteBg
        disabled={false}
        onClick={() => setOpen(true)}
        id="add-docs-button"
        cypressId="btn-training-set-add-documents"
        tooltip="Add (Upload) Documents"
      >
        <CloudUploadIcon style={{ fontSize: '14px', color: 'black' }} />
      </IconButtonWhiteBg>

      <Dialog
        id="add-docs-dialog"
        style={{ display: `${display ? '' : 'none'}` }}
        fullWidth
        maxWidth="md"
        open={open}
        onClose={(e, reason) => {
          if (reason !== 'backdropClick') {
            setOpen(false);
          }
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Documents</DialogTitle>
        <DialogContent style={{ minHeight: 115, padding: '1em 3em' }}>
          <Grid container>
            <UploadPicker
              isExtraction={false}
              dismissModal={dismissModal}
              isUpdate={true}
              trainingSet={trainingSet}
            />
          </Grid>
        </DialogContent>
        <DialogActions style={{ marginTop: '2em' }}>
          <Button
            id="add-docs-dialog-cancel"
            onClick={() => {
              setOpen(false);
            }}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TrainingSetAddDocuments;
